<template>
  <button
    v-show="hasData(data)"
    class="btn btn-primary"
    @click="onFormButtonClick(data)"
  >
    {{ getButtonText(data) }}
  </button>
</template>

<script>
export default {
  name: 'ContactButton',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    hasData (data) {
      return (data && typeof data === 'object')
    },
    getButtonText (data) {
      if (!data || typeof data !== 'object') return
      return this.$t(`${data.name}.button`)
    },
    onFormButtonClick (data) {
      this.$router.push({ name: data.name, params: { formId: data.id } })
    }
  }
}
</script>
